import { isNumber } from "lodash";
import React from "react";

import { Spacer } from "../../spacer";
import { PortalButton } from "./portal_button";
import styles from "./used_count_details_card.module.css";
import { UsedPassCountBar } from "@/offering/used_pass_count_bar";

interface UsedCountDetailsCardProps {
  title: string;
  description: string;
  usedCount: number;
  totalCount?: number;
  isExpired: boolean;
  expiredDate?: string;
  onClickBook: () => void;
  bookingDisabled?: boolean;
  bookingButtonText?: string;
  isUnlimitedPlan?: boolean;
}

export function UsedCountDetailsCard({
  title,
  description,
  usedCount,
  totalCount,
  isExpired,
  expiredDate,
  onClickBook,
  bookingDisabled,
  bookingButtonText,
  isUnlimitedPlan,
}: UsedCountDetailsCardProps) {
  const upperCaseExpiredDate = expiredDate?.toUpperCase();
  return (
    <div className={styles.component}>
      {isExpired && (
        <div>
          <div className={styles.expiredDate}>EXPIRED {expiredDate}</div>
          <Spacer size={8} />
        </div>
      )}
      <div>
        <div className={styles.title}>{title}</div>
        <Spacer size={8} />
        <div>{description}</div>
      </div>
      {!isExpired && (
        <div>
          <Spacer size={32} />
          {isNumber(totalCount) ? (
            <UsedPassCountBar usedCount={usedCount} totalCount={totalCount} />
          ) : (
            isUnlimitedPlan && <b>Unlimited bookings</b>
          )}
          <Spacer size={32} />
          <PortalButton disabled={bookingDisabled} onClick={onClickBook}>
            {bookingButtonText ?? "Book"}
          </PortalButton>
          {upperCaseExpiredDate && (
            <>
              <Spacer size={20} />
              <div className={styles.expireOn}>
                EXPIRES ON {upperCaseExpiredDate}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
